export default __webpack_public_path__ + "static/media/share.b36d6795.svg";